import { getRemotionEnvironment, prefetch } from "remotion";
import {
  CompilationTheme,
  prefetchAssetPaths,
} from "@memento/types/compilation-theme";
import { isObject } from "@memento/library/type-witchcraft";

function getValueByPath({ object, path }: { object: any; path: string }) {
  const keys = path.split(".");

  return keys.reduce((accumulator: any, key) => {
    return accumulator && accumulator[key] !== undefined
      ? accumulator[key]
      : undefined;
  }, object);
}

export function generatePrefetchUrls(
  compilationTheme: CompilationTheme
): string[] {
  const assetsToPrefetch: string[] = [];

  const { isPlayer } = getRemotionEnvironment();

  prefetchAssetPaths.forEach((objectPath) => {
    const value = getValueByPath({
      object: compilationTheme,
      path: objectPath.path,
    });

    if (value !== undefined) {
      if (objectPath.iterableRoot) {
        const zeroPad = value.zeroPad as unknown as number;
        const frameCount = value.frameCount as unknown as number;
        const urlPrefix = (isPlayer
          ? value.urlPrefix.preview || value.urlPrefix.full
          : value.urlPrefix.full) as unknown as string;
        Array.from({ length: frameCount }, (_, i) => {
          const frameNum = i.toString().padStart(zeroPad, "0");
          const frameUrl = urlPrefix.replace("{i}", frameNum);
          if (frameUrl) {
            assetsToPrefetch.push(frameUrl);
          }
        });
      } else if (typeof value === "string") {
        assetsToPrefetch.push(value);
      } else if (isObject(value)) {
        if (
          "preview" in value &&
          typeof value.preview === "string" &&
          value.preview
        ) {
          assetsToPrefetch.push(value.preview);
        }
      } else {
        throw new Error(`Unexpected asset type: ${typeof value}`);
      }
    }
  });

  return assetsToPrefetch;
}

export const prefetchAssetsUrls = async (assetsToPrefetch: string[]) => {
  try {
    await Promise.all(
      assetsToPrefetch.map((url) =>
        prefetch(url, { method: "base64" }).waitUntilDone()
      )
    );
    return true;
  } catch (error) {
    console.error("Error prefetching assets:", error);
    return false;
  }
};
